import { Stepper } from '@operations/shared';
import GenerateAccountEntries from './generateAccountEntries';
import AccountEntriesView from './accountEntriesView';
const componentSteps = [
    {
        title: 'Generate Account Entries',
        content: <GenerateAccountEntries/>,
        id: 0,
    }, {
        title: 'View',
        content: <AccountEntriesView/>,
        id: 1
    },
]
const viewAccountsEntries = () => {
  
  return (
    <div>
        <Stepper componentSteps={componentSteps}/>
    </div>
  )
}

export default viewAccountsEntries